import { AdvertisingSlot } from 'react-advertising'

import {
  FiltersAccordion,
  FiltersAccordionOrigin,
} from '@/components/srp/filters/FiltersAccordion/FiltersAccordion'
import {
  FiltersSidebarPanel,
  SkyscraperAdSlotContainer,
} from '@/components/srp/filters/FiltersSidebar/styled'
import { SrpLoading } from '@/components/srp/srp-loading'
import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'

export type FiltersSidebarProps = {
  isMobileForAds?: boolean
  isLoadingFilters?: boolean
  categoryId?: number
}

export const FiltersSidebar = ({ isMobileForAds, isLoadingFilters }: FiltersSidebarProps) => {
  return (
    <div>
      <FiltersSidebarPanel data-testid="srp-desktop-filter">
        {isLoadingFilters ? (
          <SrpLoading variant={'sidebar-filter-simplified'} />
        ) : (
          <FiltersAccordion isSimplified origin={FiltersAccordionOrigin.SIDE_PANEL} />
        )}
      </FiltersSidebarPanel>

      {!isMobileForAds && (
        <SkyscraperAdSlotContainer>
          <AdvertisingSlot
            id={GPT_COMPONENT_ID.SKYSCRAPER}
            data-testid={GPT_COMPONENT_ID.SKYSCRAPER}
          />
        </SkyscraperAdSlotContainer>
      )}
    </div>
  )
}
